module.exports = __webpack_public_path__ + "img/36.90656841.jpg";